import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit';
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { CartItemType } from 'src/types/cart/CartItem';



export interface CartState {
    items: CartItemType[],
    loading: boolean
}

const initialState: CartState = {
    items: [],
    loading: false
}

export const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        cartAddItem: (state, { payload: { cartItem } }) => {
            if (!state.items.some(item => item.slug === cartItem.slug)) {
                state.items.push(cartItem);
            }
        },

        cartRemoveItem: (state, { payload: { slug } }: PayloadAction<{ slug: string }>) => {
            const index = state.items.findIndex(item => item.slug === slug);
            if (index !== -1) {
                state.items.splice(index, 1); // removes item in place
            }
        },
        cartItemQty: (state, { payload }: PayloadAction<{ slug: string, qty: number }>) => {
            const index = state.items.findIndex(itm => itm.slug === payload.slug);
            if (index !== -1) {
                state.items[index].qty = payload.qty;
            } else {
                console.log('Item not found');
            }
        },
        cartUpdateItems: (state, { payload: { items, loading = false } }) => {
            state.items = items; // only assign if needed
            state.loading = loading;
        },

        cartReset: (state) => {
            state.items = [];
            state.loading = false;
        },
        setLoadingTrue: (state) => {
            state.loading = true;
        },
    },
})

// Action creators are generated for each case reducer function
export const {
    cartAddItem,
    cartRemoveItem,
    cartItemQty,
    cartUpdateItems,
    cartReset,
    setLoadingTrue
} = cartSlice.actions

export default cartSlice.reducer;

export const cartSelector = (state: RootState) => state.cart;
export const cartLoadingSelector = (state: RootState) => state.cart.loading;



export const cartItemsSelector = createSelector(
    [cartSelector],
    (cart) => cart.items
);


export const cartTotalSelector = createSelector(
    [cartItemsSelector],
    (items) => {
        try {
            return items?.reduce((total, item) => total + item.qty * item.disc_price, 0) || 0;
        } catch (err) {
            return 0;
        }
    }
);

export const cartDiscountTotalSelector = createSelector(
    [cartSelector],
    (cart) => {
        const discTotal = cart.items.reduce((acc, item) => {
            const price = item.disc_price ? item.disc_price : item.price;
            return acc + price * item.qty;
        }, 0);
        return discTotal;
    }
);


export const cartCountSelector = createSelector(
    [cartItemsSelector],
    (items) => (items.length)
);






